import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import DoneIcon from "@mui/icons-material/Done";
import RadioButtonCheckedRoundedIcon from "@mui/icons-material/RadioButtonCheckedRounded";
import FormControlLabel from "@mui/material/FormControlLabel";
import { customTheme } from "../../../assets/scss/theme/Theme";
import { ThemeProvider } from "@mui/material/styles";
import * as CommonStyles from "./CommonStyles";
import "./CommonStyles.scss";
import CheckBoxSelectedIcon from "../../../assets/icons/Selected.svg";

interface ImenuOptions {
  key: number;
  label: string;
}
interface ImenuItem {
  name: string;
  title: string;
  description: string;
  options: any;
  value?: any;
  onChange: any;
  width?: number | string | null | undefined;
}

const RadioComponent: FC<ImenuItem> = ({
  name,
  title,
  description,
  options = [],
  value,
  onChange
}) => {
  const { t } = useTranslation();
  return (
    <Box className="filter-section">
      <h4 style={CommonStyles.titleElement}>{t(title)}</h4>
      <Typography sx={CommonStyles.descriptionElement}>
        {t(description)}
      </Typography>

      {options.map((option: any, index: number) => {
        return (
          <FormControlLabel
            key={`radio-${name}-${option.key}-${index}`}
            style={CommonStyles.inputLablElement}
            className={`${value === option.key ? "selected" : ""}`}
            // sx={{
            //   "& .MuiRadio-root": {
            //     display: "none"
            //   }
            // }}

            value={option.key}
            control={
              <Radio
                color={"secondary"}
                value={option.key}
                checked={value === option.key}
                checkedIcon={
                  <img
                    src={CheckBoxSelectedIcon}
                    style={{ width: "1.4em", height: "1.4em" }}
                    alt="CheckBoxSelectedIcon"
                  />
                }
              />
            }
            label={
              <Typography
                width={"100%"}
                variant="h6"
                component="h6"
                sx={CommonStyles.textElement}
              >
                {t(option?.label)}
                {/* {value === option.key && <DoneIcon />} */}
              </Typography>
            }
            name={name}
            onChange={(e) => {
              onChange(e, option.key);
            }}
          />
        );
      })}
    </Box>
  );
};

export default RadioComponent;
